/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Nav_CollectionInputs */

const en_directory_nav_collection = /** @type {(inputs: Directory_Nav_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collections`)
};

const zh_directory_nav_collection = /** @type {(inputs: Directory_Nav_CollectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合集`)
};

/**
* | output |
* | --- |
* | "Collections" |
*
* @param {Directory_Nav_CollectionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_nav_collection = /** @type {((inputs?: Directory_Nav_CollectionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Nav_CollectionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_nav_collection(inputs)
	return zh_directory_nav_collection(inputs)
});
export { directory_nav_collection as "directory.nav.collection" }